<template>
  <div class="pwc-no-data">
    <span>{{ text }}</span>
  </div>
</template>

<script>
export default {
  props: {
    text: {
      type: String,
      default: '暂无数据'
    }
  }
}
</script>

<style lang="scss" scoped>
.pwc-no-data {
    text-align: center;
    height: 60px;
    span {
        color: rgba(69, 90, 100, 0.6);
        font-size: 14px;
        line-height: 60px;
        font-weight: 400;
    }
}
</style>

